import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { SearchbarItemBadge } from "components/community-search/search-bar/searchbar-item-badge";
import { StatelessSearchbarItem } from "components/community-search/search-bar/stateless-searchbar-item";
import { bestDaysToVisitOptions } from "components/details-page-v-next/visit-preferences-panel";
import { Checkbox } from "components/ui/checkbox";
import { defaultLinkStyle } from "components/ui/link";
import React from "react";

interface BestDaysToVisitFilterProps {
    value: string[];
    onChange: (bestDaysToVisit: string[]) => void;
}

export const BestDaysToVisitFilter: React.FC<BestDaysToVisitFilterProps> = props => {
    const { onChange } = props;
    const value = props.value ?? [];

    const check = (id: string) => {
        if (!value.includes(id)) {
            onChange([...value, id]);
        }
    };

    const uncheck = (id: string) => {
        onChange(value.filter(v => v !== id));
    };

    return (
        <StatelessSearchbarItem
            content={
                <div className="flex items-center space-x-2">
                    <CalendarDaysIcon className="w-5 h-5 flex-shrink-0" />
                    <span className="text-sm">Visit day</span>
                    {value.length > 0 ? (
                        <SearchbarItemBadge counter={value.length} />
                    ) : null}
                </div>
            }>
            <div className="w-40 space-y-2 p-1">
                {bestDaysToVisitOptions.map(option => (
                    <Checkbox
                        key={option.id}
                        checked={value.includes(option.id)}
                        onChange={e =>
                            e.target.checked ? check(option.id) : uncheck(option.id)
                        }
                        label={option.label}
                    />
                ))}
                {value.length > 0 ? (
                    <a
                        href="#"
                        className={`${defaultLinkStyle} block`}
                        onClick={e => {
                            e.preventDefault();
                            onChange([]);
                        }}>
                        Clear
                    </a>
                ) : null}
            </div>
        </StatelessSearchbarItem>
    );
};
